/**
 * Shared layout + surface styles for enrichment UI headers and top chrome
 * (inset from viewport, rounded, consistent with dashboard hero card).
 */

/** Horizontal inset aligned with header chrome (matches imagery shell + enrichment flow). */
export const enrichmentChromeHorizontalInset = "px-4 sm:px-6 lg:px-8";

/** Top + horizontal inset shared by enrichment sticky chrome and imagery fixed header */
export const enrichmentChromeViewportInset = `pt-3 sm:pt-4 ${enrichmentChromeHorizontalInset}`;

/** Sticky strip wrapper: breathing room from top + horizontal inset */
export const enrichmentStickyChromeOuter = `sticky top-0 z-20 ${enrichmentChromeViewportInset}`;

/** Centers content to the same column as dashboard / flow pages */
export const enrichmentChromeMaxWidth = "mx-auto w-full max-w-7xl";

/** Dark gradient panel (dashboard hero, signed-in session bar) */
export const enrichmentDarkPanelBase =
	"overflow-hidden rounded-2xl border border-gray-900/15 bg-gradient-to-r from-[#16251c] to-[#0f1b13] text-white shadow-lg ring-1 ring-black/5";

export const enrichmentDarkHeroPadding = "px-5 py-5 sm:px-6 sm:py-6";

export const enrichmentDarkSlimPadding = "px-4 py-2.5 sm:px-5 sm:py-3";

/** Light panel (job detail actions) — same geometry, light surface */
export const enrichmentLightPanelBase =
	"rounded-2xl border border-gray-200/90 bg-white/95 shadow-md ring-1 ring-gray-900/5 backdrop-blur supports-[backdrop-filter]:bg-white/90";

export const enrichmentLightSlimPadding = "px-4 py-2.5 sm:px-5 sm:py-3";
